// Chemin: C:\gestion-copro\src\App.tsx
// Point d'entrée de l'application Copro Protect
// Session 37 : Ajout CoproprieteProvider
// Session 73 : Ajout MobileWarningBanner
// Session 93 : Déplacement ChatButton/ChatPanel dans Router (useNavigate nécessite BrowserRouter)
// Session 105 : CoproprieteProvider + ChatProvider DÉPLACÉS dans Router.tsx
//               (à l'intérieur du BrowserRouter pour accès useSearchParams + useCopropriete)
// Session 182 : Suppression MobileWarningBanner — contre-productif sur la landing page,
//               le produit est responsive et utilisable sur mobile/tablette

import React from 'react';
import { AuthProvider } from './context/AuthContext';
import Router from './Router';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
};

export default App;
